module.exports = __webpack_public_path__ + "img/overseas.f9e70573.svg";